'use client';

export const TickQld = ({ className, ...props }: React.ComponentPropsWithoutRef<'svg'>) => {
	return (
		<svg
			width="32"
			height="32"
			viewBox="0 0 32 32"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			className={className}
			{...props}
		>
			<path
				d="M11.8375 22.31L26.72 7.41665C26.9317 7.21721 27.1789 7.11485 27.4617 7.10957C27.7444 7.10429 27.9944 7.20721 28.2117 7.41832C28.4289 7.63637 28.5375 7.88804 28.5375 8.17332C28.5375 8.45887 28.4289 8.70665 28.2117 8.91665L12.7512 24.3858C12.4912 24.6455 12.1867 24.7754 11.8375 24.7754C11.4886 24.7754 11.1842 24.6455 10.9242 24.3858L3.7629 17.2242C3.55624 17.0164 3.45457 16.7687 3.4579 16.4812C3.46096 16.194 3.57165 15.9418 3.78999 15.7246C4.00804 15.5143 4.25804 15.4092 4.53999 15.4092C4.82165 15.4092 5.0711 15.5143 5.28832 15.7246L11.8375 22.31Z"
				fill="currentColor"
			/>
		</svg>
	);
};
